import { HTTP } from './http_service';

export const fetchPaymentTypes = function(parcel, campaignId) {
    return HTTP.post('/ajax/types', {
        parcel: parcel,
        campaign_id: campaignId,
    }).then((types) => {
        return types.data;
    });
};

export const fetchRate = function(parcel, condition, product, paymentConditionId) {
  return HTTP.post('/ajax/getrates', {
    parcel: parcel,
    sheet_name: condition,
    product: product,
    payment_condition_id: paymentConditionId
  }).then((rate) => {
    return rate.data;
  })
};

export default {
    fetchRate,
    fetchPaymentTypes,
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/services/rate_service.js